export default {
    arrowReturn: 'arrowReturn',
    arrowProceed: 'arrowProceed',
    logo: 'logo',
    favorite: 'heart-fill',
};


// WEBPACK FOOTER //
// ./src/modules/Svg/files.tsx